<app-card titleKey="profile.legalEntityInfo">
  <app-grid-table
    [columns]="columns"
    [rowModelType]="rowModelType"
    [cacheBlockSize]="cacheBlockSize"
    [maxBlocksInCache]="maxBlocksInCache"
    [datasource]="datasource"
    [showSearch]="false"
    [autoHeight]="false"
    [rowHeight]="rowHeight"
    [gridHeight]="500"
    [loading]="isLoading()"
  ></app-grid-table>
</app-card>
,
